import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const RegistrationForm = ({ onRegistered }) => {
  const [formData, setFormData] = useState({
    UserName: '',
    Password: '',
    AuthorName: '',
    Address: '',
    EmailID: '',
    ContactNumber: '',
    WillingnessFile: null,
    IsAgree: false,
  });

  const [showTerms, setShowTerms] = useState(false);

  // NEW STATES
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);

  const API = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.IsAgree) {
      alert('You must agree to the Terms & Conditions');
      return;
    }

    setIsSubmitting(true); // Show wait message

    const formDataToSend = new FormData();
    for (const key in formData) {
      formDataToSend.append(key, formData[key]);
    }

    try {
      const response = await axios.post(
        `${API}/api/author/register`,
        formDataToSend,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );

      alert(response.data.message);

      setFormData({
        UserName: '',
        Password: '',
        AuthorName: '',
        Address: '',
        EmailID: '',
        ContactNumber: '',
        WillingnessFile: null,
        IsAgree: false,
      });

      setIsRegistered(true);
      // console.log('Registration complete: isRegistered set to true');
      // if (onRegistered) onRegistered();

    } catch (error) {
      console.error('Registration error:', error);
      alert(error.response?.data?.message || 'Something went wrong during registration.');
    } finally {
      setIsSubmitting(false); // Stop wait message
    }
  };

  return (
    <>
      <div className="container mt-5 mb-5 d-flex justify-content-center">
        <div className="card p-4 shadow-sm w-100" style={{ maxWidth: '600px' }}>
          {/* Conditional Rendering */}
          {!isSubmitting && !isRegistered && (
            <>
              <h3 className="text-center page-title mb-4">Author Registration</h3>

              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="row">
                  <div className="form-group mb-3 col-md-6">
                    <label className="form-label fw-semibold">User Name</label>
                    <input
                      type="text"
                      name="UserName"
                      className="form-control"
                      value={formData.UserName}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group mb-3 col-md-6">
                    <label className="form-label fw-semibold">Password</label>
                    <input
                      type="password"
                      name="Password"
                      className="form-control"
                      value={formData.Password}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group mb-3">
                  <label className="form-label fw-semibold">Author Name</label>
                  <input
                    type="text"
                    name="AuthorName"
                    className="form-control"
                    value={formData.AuthorName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group mb-3">
                  <label className="form-label fw-semibold">Address</label>
                  <textarea
                    name="Address"
                    className="form-control"
                    rows={3}
                    value={formData.Address}
                    onChange={handleChange}
                  ></textarea>
                </div>

                <div className="form-group mb-3">
                  <label className="form-label fw-semibold">Email</label>
                  <input
                    type="email"
                    name="EmailID"
                    className="form-control"
                    value={formData.EmailID}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group mb-3">
                  <label className="form-label fw-semibold">Contact Number</label>
                  <input
                    type="tel"
                    name="ContactNumber"
                    pattern="[0-9]{10}"
                    maxLength={10}
                    title="Enter 10-digit phone number"
                    className="form-control"
                    value={formData.ContactNumber}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group mb-4">
                  <label className="form-label fw-semibold">
                    Identification (Aadhar / PAN) (only pdf) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="file"
                    name="WillingnessFile"
                    className="form-control"
                    onChange={handleFileChange}
                    required
                  />
                </div>

                <div className="form-group mb-4 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="IsAgree"
                    name="IsAgree"
                    checked={formData.IsAgree}
                    onChange={handleChange}
                    required
                  />
                  <label className="form-check-label" htmlFor="IsAgree">
                    I have read and agree to the{' '}
                    <span
                      onClick={() => setShowTerms(true)}
                      style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                    >
                      Terms & Conditions
                    </span>
                  </label>
                </div>

                <button type="submit" className="btn btn-primary w-100">
                  Register
                </button>
              </form>
            </>
          )}

          {/* Submitting Message */}
          {isSubmitting && (
            <div className="text-center py-5">
              <h5>Please wait while we process your registration...</h5>
            </div>
          )}

          {/* Success Message */}
          {isRegistered && (
            <div className="text-left py-5">
              {console.log('Rendering success message')}
              <h5 className="fw-bold text-success mb-4">Registration submitted successfully!</h5>
              <p className="mb-2">
                <strong>A.</strong> You can use your login credentials to visit the platform dashboard only after platform host validation.
              </p>
              <p className="mb-2">
                <strong>B.</strong> You shall receive an intimation email.
              </p>
              <p className="mb-0">
                <strong>C.</strong> In case of incomplete registration, it shall remain pending until all details are provided.
              </p>
              <div className="text-center">
                <button
                  className="btn btn-success px-4"
                  onClick={() => navigate('/')}
                >
                  OK
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Terms & Conditions Modal */}
      <Modal show={showTerms} onHide={() => setShowTerms(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Author Terms & Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          <p>1. The information provided on this website is for general informational purposes only...</p>
          <p>2. This website does not provide legal, financial, medical, or professional advice...</p>
          <p>3. We are not liable for any losses or damages arising from the use of this website...</p>
          <p>4. This website is platform based process and the submission/reviewing and final selection...</p>
          <p>5. The respective hosts, authors and reviewers shall be responsible for obscene, malicious...</p>
          <p>6. This website facilitates the platform-based process of Article/paper submission...</p>
          <p>7. All concept, workflow, content, images, and other materials on this site are the property...</p>
          <p>8. We may collect personal information as described in our Privacy Policy...</p>
          <p>9. Any testimonials or endorsements on this website reflect individual experiences...</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowTerms(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RegistrationForm;
